<template>
    <v-row dense class="display-flex justify-center align-center">
        <v-col class="form" cols="12">
            <v-window v-model="step_">
                <v-window-item :value="0">
                    <UserForm
                        v-model:user="data_.user"
                        style="min-width: 49vw"
                        @userFormValidation="userFormValidation"
                    />
                </v-window-item>
                <v-window-item :value="1">
                    <CompanyForm
                        @companyFormValidation="companyFormValidation"
                        style="min-width: 49vw"
                        v-model:data="data_.company"
                    />
                </v-window-item>
                <v-window-item :value="2">
                    <OfferForm v-model:offer="data_.offer" style="min-width: 49vw"> </OfferForm>
                </v-window-item>
                <v-window-item :value="3">
                    <AccountingForm
                        v-model:data="data_.accounting"
                        :declaration="data.declaration"
                        :offer="data.offer"
                        style="max-height: 50vh; overflow-y: auto; overflow-x: hidden"
                    />
                </v-window-item>
                <v-window-item :value="4">
                    <ResumePage v-model="data_"> </ResumePage>
                </v-window-item>
                <v-window-item :value="5">
                    <EndRegisterPage> </EndRegisterPage>
                </v-window-item>
                <v-window-item :value="6">
                    <DeclarationForm v-model="data_.declaration"> </DeclarationForm>
                </v-window-item>
            </v-window>
        </v-col>
    </v-row>
</template>

<script lang="ts">
import AccountingForm from "./AccountingForm.vue";
import CompanyForm from "./CompanyForm.vue";
import DeclarationForm from "./DeclarationForm.vue";
import EndRegisterPage from "./EndRegisterPage.vue";
import OfferForm from "./OfferForm.vue";
import ResumePage from "./ResumePage.vue";
import UserForm from "./UserForm.vue";

import { CompanyVatSystem } from "@/services/vat/vatHelpers.services";
import { registrationInfo } from "@/types/registerServices.types";
import { Component, Emit, Model, Vue, Watch, toNative } from "vue-facing-decorator";

@Component({
    components: {
        UserForm,
        CompanyForm,
        AccountingForm,
        DeclarationForm,
        OfferForm,
        ResumePage,
        EndRegisterPage,
    },
})
export class InfoPage extends Vue {
    @Model({ default: null, name: "data" }) readonly data_: registrationInfo;

    @Model({ default: 0, name: "step" }) step_: number;

    @Watch("data.accounting.payedVAT")
    updateDeclarationVatSystem() {
        if (this.data_.accounting.payedVAT) {
            this.data_.declaration.vatSystem = CompanyVatSystem.Normal;
        } else {
            this.data_.declaration.vatSystem = CompanyVatSystem.NotSubjectTo;
        }
    }

    @Emit
    userFormValidation(value) {
        return value;
    }

    @Emit
    companyFormValidation(value) {
        return value;
    }

    setMaxHeightByZoom() {
        const zoomLevel = window.devicePixelRatio || 1;
    }

    beforeMount() {
        this.setMaxHeightByZoom();
        window.addEventListener("resize", this.setMaxHeightByZoom);
    }

    beforeDestroy() {
        window.removeEventListener("resize", this.setMaxHeightByZoom);
    }
}

export default toNative(InfoPage);
</script>

<style scoped>
.form {
    background-color: white;
    border-radius: 25px;
    overflow-y: hidden;
    overflow-x: hidden;
    max-height: 70vh;
    max-width: fit-content;
}
</style>
